import basicTheme from '../basicTheme.js';
import typography from '../typography.js';

const MuiFormControlLabel = {
    styleOverrides: {
        root: Object.assign({ display: 'flex', alignItems: 'center', color: basicTheme.palette.N10.main, '&:hover': {
                color: basicTheme.palette.primary.main,
            }, '.Mui-disabled': {
                color: `${basicTheme.palette.N30.main} !important`,
            } }, typography.body2),
    },
};

export { MuiFormControlLabel };
//# sourceMappingURL=MuiForm.js.map
